import { render, staticRenderFns } from "./QuizSharing.vue?vue&type=template&id=6559f288&scoped=true&"
import script from "./QuizSharing.vue?vue&type=script&lang=js&"
export * from "./QuizSharing.vue?vue&type=script&lang=js&"
import style0 from "./QuizSharing.vue?vue&type=style&index=0&id=6559f288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559f288",
  null
  
)

export default component.exports